import React from 'react';

import { Button, Col, Form, Input, Row } from 'antd';

import '../../admin/assets/css/login.css';
import { useManagerLoginMutation } from '../complianceManagerSlice';
import { notification } from '../../../../utils/messaging';
import { event_super_admin_url } from '../../../../eventSuperAdminRoutes';
import { useHistory } from 'react-router-dom';

export default function EventSuperAdminLogin(props) {
  const history = useHistory();
  const [login, { isLoading: isLoggingIn }] = useManagerLoginMutation();

  return (
    <div className='admin-login-page sb-dark-blue-bg'>
      <div id='admin-login-form-content'>
        <div className='login-inside-form-content'>
          <Row>
            <Col span={24} className='txt-center mg-bottom-20'>
              <span className='admin-logo-text gSemiBold'>
                <span className='sb-blue fs-30 mg-right-5'>Events Admin</span>{' '}
                <span className='fs-30'>Management Portal</span>
              </span>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <div className='admin-login-form-wrapper'>
                <div className='admin-login-form-items'>
                  <Form
                    name='basic'
                    initialValues={{
                      remember: true,
                    }}
                    onFinish={(values) => {
                      if (!values?.username ?? !values?.password) {
                        notification.warning({
                          description: 'Please provide your email and password',
                        });
                        return;
                      }
                      login({
                        username: values.username,
                        password: values.password,
                      }).unwrap().then(() => {
                        history.push(`${event_super_admin_url}/dashboard`);
                      });
                    }}
                  >
                    <p className='dark-swim-blue gSemiBold mg-bottom-5'>
                      Email:
                    </p>
                    <Form.Item
                      name='username'
                      rules={[
                        {
                          required: true,
                          message: 'Please input your username!',
                        },
                      ]}
                    >
                      <Input className='br5 email' />
                    </Form.Item>
                    <p className='dark-swim-blue gSemiBold mg-bottom-5'>
                      Password:
                    </p>
                    <Form.Item
                      name='password'
                      rules={[
                        {
                          required: true,
                          message: 'Please input your password!',
                        },
                      ]}
                    >
                      <Input.Password className='br5 admin-secret' />
                    </Form.Item>

                    <Form.Item>
                      <Button
                        className='admin-login-btn light-green-bg gBold'
                        type='primary'
                        htmlType='submit'
                        loading={isLoggingIn}
                      >
                        SIGN IN
                      </Button>
                    </Form.Item>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}
